/**
 * Legacy DepartmentsApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.departmentsApi`) keep resolving.
 *
 * The actual DepartmentsApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/departments/departments-api.service.ts
 */
angular.module("acme.common.service.departmentsApi", [
  "acme.common.factory.QueryStringBuilder",
]);
